// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Link from "../Link.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Patch from "common/src/Patch.bs.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ItemTooltip from "common/src/tft-static/ItemTooltip.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as Translation2 from "common/src/bindings/Translation2.bs.js";
import * as AugmentTooltip from "common/src/tft-static/AugmentTooltip.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import Format from "date-fns/format";
import * as InfoContentSection from "./InfoContentSection.bs.js";

function getImg(contents, set) {
  var contents$1 = contents.replace("’", "'").toLowerCase();
  var aug = Js_dict.entries(Data.augments(set)).find(function (param) {
        return contents$1.startsWith(param[1].name.toLowerCase());
      });
  if (aug !== undefined) {
    return {
            TAG: /* Augment */3,
            _0: aug[0]
          };
  }
  var u = Belt_Option.map(Caml_option.undefined_to_opt(Sd.allUnits(set).find(function (u) {
                return contents$1.startsWith(Translation2.units(u).toLowerCase());
              })), (function (unitId) {
          return {
                  TAG: /* Unit */0,
                  _0: unitId
                };
        }));
  if (u !== undefined) {
    return u;
  }
  var t = Sd.allTraits(set).find(function (t) {
        return contents$1.startsWith(Translation2.traits(t).toLowerCase());
      });
  if (t !== undefined) {
    return {
            TAG: /* Trait */1,
            _0: t
          };
  }
  var i = Js_dict.entries(Data.items(set)).find(function (param) {
        return contents$1.startsWith(param[1].name.toLowerCase());
      });
  if (i !== undefined) {
    return {
            TAG: /* Item */2,
            _0: i[0]
          };
  }
  
}

function PatchNotesPage$ListItem(Props) {
  var contents = Props.contents;
  var img = Props.img;
  var sameImg = Props.sameImg;
  var tmp;
  if (!sameImg && Belt_Option.isSome(img)) {
    var tmp$1;
    if (sameImg || img === undefined) {
      tmp$1 = null;
    } else {
      switch (img.TAG | 0) {
        case /* Unit */0 :
            var unitId = img._0;
            tmp$1 = React.createElement(UnitTooltip.make, {
                  unit: unitId,
                  children: React.createElement(UnitImage.make, {
                        unitId: unitId,
                        size: 30
                      })
                });
            break;
        case /* Trait */1 :
            var traitId = img._0;
            tmp$1 = React.createElement(TraitTooltip.make, {
                  trait: traitId,
                  children: React.createElement(TraitImage.PlainIcon.make, {
                        traitId: traitId,
                        size: 30
                      })
                });
            break;
        case /* Item */2 :
            var itemId = img._0;
            tmp$1 = React.createElement(ItemTooltip.make, {
                  itemId: itemId,
                  children: React.createElement(ItemImage.make, {
                        itemId: itemId,
                        size: 28
                      })
                });
            break;
        case /* Augment */3 :
            var augId = img._0;
            tmp$1 = React.createElement(AugmentTooltip.make, {
                  id: augId,
                  children: React.createElement(AugmentImage.make, {
                        augId: augId,
                        size: 30
                      })
                });
            break;
        
      }
    }
    tmp = React.createElement("div", {
          className: "flex-shrink-0 w-8 h-8 flex items-center justify-center"
        }, tmp$1);
  } else {
    tmp = React.createElement("div", {
          className: "flex-shrink-0 w-8"
        });
  }
  return React.createElement("div", {
              className: "flex items-center" + (
                sameImg ? "" : " pt-2"
              )
            }, tmp, React.createElement("div", {
                  className: "pb-1 pl-[6px]" + (
                    sameImg ? "" : " pt-1"
                  )
                }, contents));
}

var ListItem = {
  make: PatchNotesPage$ListItem
};

function PatchNotesPage$PatchHeader(Props) {
  var date = Props.date;
  var patch = Props.patch;
  var activePatch = Props.activePatch;
  return React.createElement(Link.make, {
              route: {
                TAG: /* Info */6,
                _0: {
                  TAG: /* PatchNotes */7,
                  _0: patch
                }
              },
              children: React.createElement("div", {
                    className: "px-4 sm:px-0 py-3 cursor-pointer" + (
                      patch === activePatch ? " text-primary-11" : ""
                    )
                  }, React.createElement("span", {
                        className: "pr-2 inline-block text-right text-xs w-[48px] opacity-60"
                      }, date), "Patch " + patch)
            });
}

var PatchHeader = {
  make: PatchNotesPage$PatchHeader
};

function PatchNotesPage(Props) {
  var allPatches = Props.allPatches;
  var data = Props.data;
  var set = TftSet.use(undefined);
  var data$1 = data[1];
  var activePatch = data[0];
  var prevImg = {
    contents: undefined
  };
  return React.createElement(React.Fragment, undefined, React.createElement(InfoContentSection.make, {
                  children: React.createElement("div", {
                        className: "flex flex-col sm:flex-row"
                      }, React.createElement("div", {
                            className: "flex flex-wrap sm:flex-col min-w-[180px]"
                          }, Belt_Array.map(allPatches, (function (patch) {
                                  var v = LpChartUtils.newPatchDays.find(function (param) {
                                        return param[1] === Patch.render(patch);
                                      });
                                  var p = v !== undefined ? v : Caml_option.undefined_to_opt(LpChartUtils.newPatchDays.find(function (param) {
                                              return param[1] === Patch.render(patch).replace("0", "");
                                            }));
                                  var date = Belt_Option.getWithDefault(Belt_Option.map(p, (function (param) {
                                              return Format(new Date(param[0]), "MMM d");
                                            })), "");
                                  return React.createElement(PatchNotesPage$PatchHeader, {
                                              date: date,
                                              patch: Patch.render(patch),
                                              activePatch: Patch.render(activePatch),
                                              key: String(patch)
                                            });
                                }))), React.createElement("div", {
                            className: "flex flex-col"
                          }, React.createElement("a", {
                                className: "text-primary-11 cursor-pointer ml-auto block mb-3",
                                href: data$1.url,
                                target: "_blank"
                              }, "Official Riot patch notes"), Belt_Array.map(data$1.sections, (function (section) {
                                  return React.createElement(ContentSection.make, {
                                              level: 2,
                                              className: "mb-8",
                                              children: null,
                                              key: section.header
                                            }, React.createElement("h2", {
                                                  className: "mb-4 text-3xl"
                                                }, section.header), Belt_Array.mapWithIndex(section.data, (function (idx, d) {
                                                    var header = d.header;
                                                    var quote = d.quote;
                                                    return React.createElement("div", {
                                                                key: String(idx)
                                                              }, header !== undefined ? React.createElement("h4", {
                                                                      className: "mt-6 text-xl pb-4"
                                                                    }, header) : null, quote !== undefined ? React.createElement("div", {
                                                                      className: "leading-tight pt-4 pb-2"
                                                                    }, React.createElement("fieldset", {
                                                                          className: CssJs.merge([
                                                                                "text-sm rounded pl-3 pr-3 pt-1",
                                                                                CssJs.style([CssJs.border(CssJs.px(1), CssJs.solid, CssJs.rgba(255, 255, 255, {
                                                                                                NAME: "num",
                                                                                                VAL: 0.6
                                                                                              }))])
                                                                              ])
                                                                        }, React.createElement("legend", {
                                                                              className: "px-1"
                                                                            }, "Developer's notes"), Belt_Array.mapWithIndex(quote, (function (idx, q) {
                                                                                return React.createElement("div", {
                                                                                            key: String(idx),
                                                                                            className: "pb-2"
                                                                                          }, q);
                                                                              })))) : null, React.createElement("div", {
                                                                    className: "leading-tight"
                                                                  }, Belt_Array.mapWithIndex(d.list, (function (idx, item) {
                                                                          var skipImage = section.header === "Systems" || section.header === "Bug Fixes";
                                                                          var img = skipImage ? undefined : getImg(item, set);
                                                                          var sameImg = Belt_Option.isSome(img) && Caml_obj.caml_equal(prevImg.contents, img);
                                                                          if (Belt_Option.isSome(img) && !sameImg) {
                                                                            prevImg.contents = img;
                                                                          }
                                                                          return React.createElement(PatchNotesPage$ListItem, {
                                                                                      contents: item,
                                                                                      img: img,
                                                                                      sameImg: sameImg,
                                                                                      key: String(idx)
                                                                                    });
                                                                        }))));
                                                  })));
                                }))))
                }));
}

var make = PatchNotesPage;

export {
  getImg ,
  ListItem ,
  PatchHeader ,
  make ,
  
}
/* Sd Not a pure module */
